
import Vue from 'vue';
import _ from 'lodash';
import { mapState } from 'vuex';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      checkbox: false
    }
  },
  computed: {
    disabled: function(): boolean {
      return this.rowDisabled || this.parent._getDisableStatus(this.input.disabled);
    },
    sellingUnits: function() {
      let sellingUnits: any[] = [];
      const packingModeData: any[] = this.input.variable && this.getVariable(this.input.variable) ? this.getVariable(this.input.variable) : []; 
      packingModeData.forEach((packingStage: any, index: number) => {
        const { unit1, unit2 } = packingStage;
        if(!sellingUnits.includes(unit1)) {
          const text = `${unit1} (1 ${unit1})`;
          sellingUnits.push({ value: unit1, text });
        }
        if(!sellingUnits.includes(unit2)) {
          let text = '';
          if(index == 0) {
            text = `${unit2} (${packingModeData[index].quantity} ${unit1} x 1 ${unit2})`;
          } else {
            text = `${unit2} (${packingModeData[0].quantity} ${packingModeData[0].unit1} x ${packingModeData[1].quantity} ${packingModeData[1].unit1} x 1 ${unit2})`;
          }
          sellingUnits.push({ value: unit2, text });
        }
      });
      return sellingUnits;
    },
    sellingUnitVariable: function() {
      const config: any = this.input.config; 
      return config.sellingUnit;
    },
    ...mapState({
      packingLevels(state: any) {
        const packingLevels = _.get(state, 'staticData.packing-level');
        return _.map(packingLevels, (units: string[], level: string) => {
          return { units, level };
        })
      }
    })
  },
  watch: {
    checkbox(value: boolean) {
      const packingModeData: any[] = this.getVariable(this.input.variable);
      if(value && packingModeData.length == 1) {
        packingModeData.push({ unit1: packingModeData[0].unit2, quantity: null, unit2: this.packingLevels[2].units[0]});
      } else if(!value && packingModeData.length == 2) {
        packingModeData.pop();
      }
      const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
      this.$set(this.parent._getVariable(prefix), key, packingModeData);
      this.checkAndResetSellingUnit();
    }
  },
  mounted() {
    this.$watch(
      () => this.parent._getVariable(this.input.config.productLine), 
      () => {
        this.initialisePackingFormData();
      },
      { immediate: true }
    )
  },
  methods: {
    initialisePackingFormData: function() {
      const { _getVariable , _getPrefixAndKey } : any = this.parent;
      const packingModeData: any[] = this.getVariable(this.input.variable);
      if (!packingModeData || packingModeData.length === 0) {
        const { prefix, key } =_getPrefixAndKey(this.input.variable);
        const initialValue = this.packingLevels.reduce((acc : Array<{ quantity: number | null, unit1: string, unit2: string }>, val : any, index : number) => {
          if (index < this.packingLevels.length - 1) {
            acc.push({
              quantity: null,
              unit1: this.packingLevels[index].units[0],
              unit2: this.packingLevels[index + 1].units[0],
            })
          }
          return acc;
        }, []);
        this.$set(_getVariable(prefix), key, this.checkbox ? initialValue : initialValue.slice(1));
      } else if(packingModeData.length > 1) {
        this.checkbox = true;
      }
    },
    onChangeUnit: function(i : any) {
      const unitGroups = this.parent._getVariable(this.input.variable);
      if (i < unitGroups.length - 1) {
        unitGroups[i + 1].unit1 = unitGroups[i].unit2;
      }
    },
    checkAndResetSellingUnit: function() {
      const currentSellingUnit = this.getVariable(this.sellingUnitVariable);
      if(this.sellingUnits.findIndex(item => item.value == currentSellingUnit) == -1) {
        const { prefix, key } = this.parent._getPrefixAndKey(this.sellingUnitVariable);
        this.$set(this.parent._getVariable(prefix), key, '');
      }
    }
  },
})
